
import React from 'react';
import { Layout } from '@/components/Layout';

const AdminPage = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>
        <p>Admin functionality is currently not available in this parent-focused MVP.</p>
      </div>
    </Layout>
  );
};

export default AdminPage;
